let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8cB8p")).then(() => parcelRequire('aoDXB'));